import validate from 'lib/utils/validationRules';

import StructHelper from '@/services/StructHelper';
import SubscriptionCard from '@/pages/subscriptions/classes/SubscriptionCard';

import { BOT_SIGN_ON_EVENT, BOT_SIGN_OFF_EVENT } from '@/const';

export default {
  SET_MERCHANT_INFO(state, merchantInfo) {
    state.MERCHANT_INFO = merchantInfo;
  },

  SET_PROJECT_INFO(state, projectInfo) {
    state.PROJECT_INFO = projectInfo;
  },

  SET_PROJECT_LIST(state, projects) {
    state.PROJECT_LIST = projects;
  },

  SET_PARTNER_INFO(state, partnerInfo) {
    state.PARNTER_INFO = partnerInfo;
  },

  SET_WINDOW_SIZE(state) {
    state.WINDOW_SIZE = document.documentElement.clientWidth;
  },

  SET_SCROLL_STATES(state, { type, params }) {
    state.SCROLL_STATES[type] = params;
  },

  SET_MODAL_PARAMS(state, { type, params }) {
    for (let param in params) {
      state.MODALS[type][param] = params[param];
    }
  },

  DEVICE_DETECT(state, { isIOS, isAndroid, isMobile, isMobileOnly }) {
    state.DEVICE.isIOS = isIOS;
    state.DEVICE.isAndroid = isAndroid;
    state.DEVICE.isMobile = isMobile;
    state.DEVICE.isMobileOnly = isMobileOnly;
  },

  SET_TRANSACTIONS_PARAMS(state, params) {
    for (let param in params) {
      if (param === 'result') {
        if (params.resetResult) {
          state.TRANSACTIONS.result = params.result;
        } else {
          state.TRANSACTIONS.result.push(...params.result);
        }
      } else {
        state.TRANSACTIONS[param] = params[param];
      }
    }
  },

  SELECT_TRANSACTION(state, transaction) {
    state.SELECTED_TRANSACTION = transaction;
  },

  CLOSE_TRANSACTION(state) {
    state.SELECTED_TRANSACTION = {};
  },

  SET_GRAPH(state, graph) {
    state.GRAPH = StructHelper.toGraphFormat(graph);
  },

  CHANGE_SELECTED_TRANSACTION_CURRENCY(state, currency) {
    state.SELECTED_TRANSACTION.currency = currency;
  },
  CHANGE_SELECTED_TRANSACTION_BILL_TARIFFS(state, billTariffs) {
    state.SELECTED_TRANSACTION.billTariffs = billTariffs;
  },
  CHANGE_SELECTED_TRANSACTION_DECLARED(state, declared) {
    state.SELECTED_TRANSACTION.declared = declared;
  },
  CHANGE_SELECTED_TRANSACTION_MARKETPLACE(state, onMarketplace) {
    state.SELECTED_TRANSACTION.onMarketplace = onMarketplace;
  },
  CHANGE_SELECTED_TRANSACTION_MARKETPLACE_CATEGORY_ID(state, categoryId) {
    state.SELECTED_TRANSACTION.marketplaceCategoryId = categoryId;
  },
  CHANGE_SELECTED_TRANSACTION_APPLY_PROMO_CODE(state, applyPromoCode) {
    state.SELECTED_TRANSACTION.applyPromoCode = applyPromoCode;
  },
  CHANGE_SELECTED_TRANSACTION_PROMO_CODE_APPLICABLE(state, promoCodeApplicable) {
    state.SELECTED_TRANSACTION.promoCodeApplicable = promoCodeApplicable;
  },
  CHANGE_SELECTED_TRANSACTION_DEAL(state, deal) {
    state.SELECTED_TRANSACTION.deal = deal;
  },
  CHANGE_SELECTED_TRANSACTION_TIPS_VARIANTS(state, tipsVariants) {
    state.SELECTED_TRANSACTION.tipsVariants = tipsVariants;
  },

  SET_REGISTRATION_PROCESS(state, params) {
    try {
      const localData = JSON.parse(localStorage.getItem('registration'));
      localStorage.setItem('registration', JSON.stringify({
        ...localData,
        [params.state]: params.data,
      }));
    } catch (error) { /**/ }

    state.REGISTRATION[params.state] = params.data;
  },

  SET_LAST_CARD_BINDING_PAGE(state, currentPage) {
    state.LAST_CARD_BINDING_PAGE = currentPage;
  },

  SET_CARD_BINDING_TOKEN(state, token) {
    state.CARD_BINDING_TOKEN = token;
  },

  REMOVE_CARD_BINDING_TOKEN(state) {
    state.CARD_BINDING_TOKEN = '';
  },

  RESET_TRANSACTIONS(state) {
    state.TRANSACTIONS.result = [];
    state.TRANSACTIONS.page = 1;
    state.TRANSACTIONS.searchText = '';
    state.TRANSACTIONS.filterBy = 'all';
    state.TRANSACTIONS.loading = false;
  },

  CLEAR_ALL_STATE(state) {
    state.MERCHANT_INFO = {};
    state.PROJECT_INFO = {};
    state.SELECTED_TRANSACTION = {};
    state.REGISTRATION.LOGIN = '';
    state.REGISTRATION.PROJECT_LINK = '';
    state.REGISTRATION.PROJECT_NAME = '';
    state.TRANSACTIONS.result = [];
    state.TRANSACTIONS.page = 1;
    state.TRANSACTIONS.search_text = '';
    state.TRANSACTIONS.filter_by = 'all';
    state.TRANSACTIONS.loading = false;
    state.GRAPH = [];
  },

  SET_THEME(state, theme) {
    let app = document.getElementsByTagName('body')[0];
    app.className = theme;

    state.MERCHANT_INFO.theme = theme;
  },

  SET_SELF_EMPLOYED_STATUS(state, status) {
    state.SELF_EMPLOYED.status = status;
  },
  SET_SELF_EMPLOYED_ID(state, id) {
    state.SELF_EMPLOYED.requestId = id;
  },
  SET_SELF_EMPLOYED_PROPERTIES(state, properties) {
    state.SELF_EMPLOYED.properties = properties;
  },

  SELF_EMPLOYED_LOADING(state, loading) {
    state.SELF_EMPLOYED.loading = loading;
  },

  SET_SELF_EMPLOYED_NOTIFICATION_LOADING(state, loading) {
    state.SELF_EMPLOYED.notifications.loading = loading;
  },

  SET_SELF_EMPLOYED_NOTIFICATIONS(state, notifications) {
    state.SELF_EMPLOYED.notifications.list = notifications;
    state.SELF_EMPLOYED.notifications.count = notifications.length;
  },

  SET_SUBSCRIPTIONS_PARAMS(state, params) {
    for (let param in params) {
      if (param === 'subscribers') {
        if (params.resetSubscriber) {
          state.SUBSCRIPTIONS.subscribers = params.subscribers;
        } else {
          state.SUBSCRIPTIONS.subscribers.push(...params.subscribers);
        }
      } else {
        state.SUBSCRIPTIONS[param] = params[param];
      }
    }
  },

  SELECT_SUBSCRIPTION(state, subscription) {
    state.SELECTED_SUBSCRIPTION = subscription;
  },

  CLOSE_SUBSCRIPTION(state) {
    state.SELECTED_SUBSCRIPTION = {};
  },

  RESET_SUBSCRIPTIONS(state) {
    state.SUBSCRIPTIONS.result = [];
    state.SUBSCRIPTIONS.page = 1;
    state.SUBSCRIPTIONS.searchText = '';
    state.SUBSCRIPTIONS.filterBy = '';
    state.SUBSCRIPTIONS.loading = false;
  },

  SET_WRITE_OFF_OPTIONS(state, options) {
    state.WRITE_OFF_OPTIONS = options;
  },

  UPDATE_STATUS_SUBSCRIPTION(state, subscriptionId) {
    const { subscribers: subscriptions } = state.SUBSCRIPTIONS;
    const findedSubscription = subscriptions.find(subscription => Number(subscription.id) === Number(subscriptionId));

    if (validate.isUndefined(findedSubscription)) {
      return;
    }

    findedSubscription.status = SubscriptionCard.statuses.INACTIVE;
  },

  SET_MARKETPLACE_CATEGORIES(state, categories) {
    state.MARKETPLACE_CATEGORIES = categories;
  },

  SET_BOT_SIGNED_EVENT(state, isSigned) {
    state.MERCHANT_INFO.botSigned = isSigned;

    const event = isSigned ? BOT_SIGN_ON_EVENT : BOT_SIGN_OFF_EVENT;
    window.dispatchEvent(new Event(event));
  },

  SET_PROMOCODE(state, payload) {
    state.PROJECT_INFO.promoCode = payload;
  },

  REMOVE_PROMOCODE(state) {
    state.PROJECT_INFO.promoCode = null;
  },

  SET_LOCALE(state, locale) {
    state.PROJECT_LOCALE = locale;
    localStorage.setItem('lang', JSON.stringify(locale.language));
  },

  UPDATE_DEAL_STATUS(state, deal) {
    if (!state.TRANSACTIONS.result) {
      return null;
    }

    let transaction = state.TRANSACTIONS.result
      .filter(transaction => transaction.deal)
      .find(transaction => transaction.deal.id === deal.id);

    if (validate.isUndefined(transaction)) {
      return null;
    }

    transaction.deal = deal;

    return transaction;
  },

  SET_MERCHANT_TIMEZONE(state, timezone) {
    state.MERCHANT_INFO.timezone = timezone;
  },
};
